module.exports = __webpack_public_path__ + "static/logo_en_white-70520e6af6bafb62f11c05ce7887ee2d.png";